<template>
    <main class="healthCheck" data-ui-page="healthCheck">
        <div class="healthCheck-wrap">
            <div class="healthCheck-head">
                <div class="healthCheck-head-group"> 
                    <!-- <h1><span class="a11y-hidden">KB헬스케어</span></h1> -->
                    <router-link :to="{ path: '/' }">
                    <span class="btn-home"><span class="a11y-hidden">KB헬스케어</span></span>
                    </router-link>
                </div>
                
                <!-- <h2 class="healthCheck-head-tit">
                  올바른 라이프케어의 시작<br>
                  <b>매일의 작은 변화</b>로 시작하세요
                </h2>
                <p class="healthCheck-head-txt">앱 설치하고 건강관리 시작하기!</p>

                <div class="btn-area">
                  <a href="https://apps.apple.com/kr/app/id1597675315" class="btn app apple" target="_blank" title="새창열림"><span>App Store</span></a>
                  <a href="https://play.google.com/store/apps/details?id=com.kb.ocare.app" class="btn app google" target="_blank" title="새창열림"><span>Google Play</span></a>
                </div> -->
            </div>
            <div class="healthCheck-iframe">
                <iframe src="https://ollacare.com/" frameborder="0" ></iframe>
                <div class="healthCheck-iframe-nav">
                  <router-link :to="{ path: '/' }" class="fb-home" aria-label="KB헬스케어 홈">
                </router-link>
                </div>
            </div>
        </div>
    </main>
</template>

<script setup>

</script>

<style scoped>
.healthCheck-iframe-nav {
  position: absolute; 
  bottom:0;
  height: 3rem;
  width: 100%;
  background: #ffd551;
  align-items: center;
  justify-content: center;
  display: none
}
.fb-home{
  width: 4.8rem;
  height: 4.8rem; 
  border-radius: 50%; 
  background: url(@/resources/img/fb-kbhealthcare.png) no-repeat 50% 50% / 5rem; 
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 0.8rem #e39500;
  transform: translateY(-1.5rem);
  /* box-shadow: 0rem 0.6rem 1.6rem 0rem #EFDB43; */
}
.btn-area{
  display: flex; gap:1.2rem;
  .btn.app {
    background: #fff;
    color:#000;
  }
}
.a11y-hidden {
    position: absolute !important;
    width: .1rem !important;
    height: .1rem !important;
    color: transparent !important;
    overflow: hidden !important;
    clip: rect(.1rem, .1rem, .1rem, .1rem);
    clip-path: inset(50%);
    margin: 0 !important;
    padding: 0 !important;
}
.healthCheck {
    position: fixed;
    width:100%;
    height: 100%;
    top:0;
    left:0;
    z-index: 100;
    overflow: hidden;
}
.header{display: none !important;}
.healthCheck-iframe {
    width:100%;
    height: 100dvh;
    background: #fff;
    transition: width .2s ease-in;
    position: relative;
}
.healthCheck-iframe iframe{
    border:0;
    width:100%;
    height: 100dvh;
}
.healthCheck-wrap {
    position: relative;
    display: flex;
    width: 100%;
    height: 100dvh;
    justify-content: center;
    align-items: center;
    gap:16.5rem;
}
.healthCheck-head{
    position: absolute;
    top:50%;
    left:50%;
    transform: translate(-34rem, 18rem);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    z-index: 2;

}
.healthCheck-head-group{
    display: flex;
    gap:2rem;
    justify-content: flex-start;
    align-items: center;
}

.healthCheck-head h1{
    width:19.4rem;
    height: 3.6rem;
}
.healthCheck-head-tit{
    font-size: 4.2rem;
    font-weight: 300;
    color: #6e4ec9;
    line-height: 1.4;
    margin-bottom: 4.6rem;
    letter-spacing: -0.2rem;
}
.healthCheck-head-txt {
  font-size: 2.2rem;
  margin-bottom: 2.4rem;
  color:#472c91;
}
.healthCheck-head-tit b{
    font-weight: 700;
    color: #472c91;
}

.btn-home {
    width: 15rem;
    min-height: 3.6rem;
    padding: 0 1.2rem;
    font-size: 1.4rem;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    gap: .6rem;
    white-space: nowrap;

    background-image: url("data:image/svg+xml,%3Csvg width='194' height='36' viewBox='0 0 194 36' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_22_200)'%3E%3Cg clip-path='url(%23clip1_22_200)'%3E%3Cpath d='M44.2509 19.4451L43.8602 19.1999C42.5453 17.8823 40.7077 17.3111 38.253 17.4539C36.2106 17.5805 34.5913 18.3889 33.3518 19.1433C33.3518 19.1244 33.3518 19.1056 33.3518 19.0894C33.3518 18.4481 33.4246 17.753 33.4973 17.082C33.5674 16.395 33.6428 15.6971 33.6428 15.0397C33.6428 14.3822 33.5674 13.7275 33.3357 13.1832C33.2764 13.0431 33.1497 12.9595 32.9827 12.9595C32.3226 12.973 31.0346 13.4257 30.7221 13.7005L30.5523 14.0697C30.5415 14.8025 30.3799 16.8422 30.2182 17.0928C30.2236 17.0847 30.132 17.338 30.132 17.338C29.8517 20.2534 29.8464 22.8158 30.105 25.0172C30.1347 25.2381 30.5577 25.5669 30.8837 25.6881C31.2421 25.8174 32.3657 25.5184 33.0123 25.2759C33.0069 25.2759 33.2575 25.2354 33.2575 25.2354C33.4623 25.2112 33.5809 25.0387 33.5728 24.807C33.5701 24.8016 33.5889 24.1738 33.5889 24.1738C34.0551 22.2742 35.9466 20.0109 38.1857 19.6687C39.4494 19.4666 40.449 19.7927 41.2385 20.6522C41.3462 20.8085 41.5753 22.1772 40.7427 23.7454C40.123 24.9094 38.8808 25.8902 37.248 26.5018C35.7041 27.0892 34.0012 27.3263 31.9022 27.2536C31.816 27.1997 29.9353 25.9252 29.9353 25.9252C28.2701 24.7558 26.2008 23.2981 24.3254 22.5868C23.9967 22.4629 23.4039 21.9725 23.0483 21.6788L22.857 21.5198C21.7738 20.6522 19.7152 19.278 18.0636 18.1787C18.0636 18.1787 17.3172 17.6775 17.1717 17.5832C17.1717 17.5212 17.1744 17.3973 17.1744 17.3973C17.2229 17.3434 18.2602 16.721 18.2602 16.721C19.7152 15.8695 20.3862 15.4519 20.529 15.2364C20.4993 15.2741 20.723 15.1232 20.723 15.1232C20.7364 15.1151 24.3281 13.0835 24.3281 13.0835C27.7905 11.1785 31.7109 9.02296 33.7695 6.88896C33.7695 6.88627 33.8692 6.56294 33.8692 6.56294L33.9177 6.27194C34.0524 5.81658 34.0605 5.4663 33.9446 5.06213C33.9177 4.94627 33.8072 4.81155 33.6644 4.7873C32.0558 4.62833 29.9838 5.59024 28.095 7.36319C27.6692 7.76196 27.3109 7.95866 26.9337 8.16074L26.6454 8.32241C24.5626 9.50796 19.8742 12.418 17.4169 13.9861C17.5786 11.3483 18.0662 7.59221 18.6698 4.46127L18.6024 4.08944C18.5971 4.07596 18.3492 3.61521 18.3492 3.61521L18.1579 3.27841L18.1013 3.26224C17.6136 3.01435 17.2121 3.11405 16.9184 3.1868L16.428 3.37002L15.7733 3.60713C15.6466 3.63408 15.5523 3.71491 15.5038 3.83885C14.3317 6.67071 13.3537 11.3321 13.1219 15.0612C10.7805 13.5712 8.61414 12.4988 7.55253 11.9815L7.52289 11.9653L7.39625 11.9384C7.01364 11.8872 6.5475 11.6069 6.10022 11.3375C6.05172 11.3079 5.20836 10.7609 5.20836 10.7609L3.84767 9.89058L3.4893 9.80705C2.90461 9.90944 1.78372 10.6639 1.44961 11.1785C1.4065 11.2459 1.38764 11.3213 1.38764 11.3968C1.38764 11.5019 1.42267 11.615 1.44961 11.7174L1.50889 11.9976L1.57355 12.1647C2.2283 12.8329 3.87192 13.9457 5.48858 14.816L7.36122 15.8076L10.2254 17.373C10.2254 17.3865 10.7131 17.761 10.7131 17.761L11.0499 17.955C11.0499 17.955 11.0903 17.9766 11.1119 17.9955C10.3467 18.5074 5.90083 21.4767 5.90083 21.4767L3.16058 23.29C2.90192 23.4679 1.81875 23.9529 1.58164 24.0472C0.986166 24.2897 0.538888 24.6615 0.350277 25.0657L0.277527 25.222L0.350277 25.3297L0.560444 25.486L0.840666 25.6692L1.14514 25.8794L1.43075 25.9225C1.91305 25.9414 2.62439 25.6665 3.95814 25.0819C5.18142 24.5403 8.51175 22.5329 9.93172 21.6761L10.5407 21.3123C10.7912 21.3312 11.0661 21.121 11.314 20.9351C11.5996 20.7061 12.2193 20.3262 12.5965 20.1591C12.61 20.1537 12.8256 20.0325 13.0276 19.922C13.0276 19.9867 13.0276 20.0837 13.0276 20.0837C13.0896 24.4379 13.3402 27.5985 13.8171 30.0396L13.8225 30.0827L13.871 30.1797C14.1054 30.5246 14.3722 31.5566 14.6093 32.4646L15.1509 34.2807C15.1643 34.3022 15.3017 34.4531 15.3017 34.4531C15.6116 34.6606 16.5574 35.0244 17.1852 34.9489L17.3441 34.93L17.4438 34.7091C17.4977 34.437 17.5139 34.1729 17.5139 33.8792C17.5139 33.5451 17.4896 33.1787 17.46 32.7287L17.4169 32.0766C17.2175 29.04 17.0181 24.6507 17.0181 21.7354V21.5036C17.5354 21.8297 19.7907 23.2496 19.7907 23.2496C23.6357 25.742 29.4395 29.5088 32.945 30.5058C33.1282 30.5624 33.3195 30.5192 33.4542 30.3899C33.4596 30.3845 33.9931 30.0423 33.9931 30.0423L34.0928 30.0019C34.2949 29.9049 34.4296 29.5681 34.4539 29.199C37.4124 29.0481 41.5349 27.911 43.7389 25.1357C44.5957 24.058 44.9784 22.7431 44.9784 21.6168C44.9784 20.6926 44.7224 19.895 44.2562 19.4585' fill='%23FCAF17'/%3E%3Cpath d='M55.1606 7.55983H58.6203V17.2544L70.263 7.55983H75.1588L62.8559 17.3461L76.18 29.2232H71.2869L58.6203 17.6155V29.2232H55.1606V7.55983Z' fill='%23FFFFFF'/%3E%3Cpath d='M78.5915 7.56253H89.24C94.3082 7.56253 96.9542 9.24386 96.9542 12.9218C96.9542 15.5381 95.1273 17.3407 92.6969 17.8257V17.9173C96.1836 18.3322 97.8299 20.6171 97.8299 23.1957C97.8299 26.4317 95.4641 29.2259 89.5768 29.2259H78.5915V7.56253ZM82.0431 16.6859H89.0675C91.6784 16.6859 93.605 15.6944 93.605 13.3879C93.605 11.3725 92.6538 10.0279 88.6687 10.0279H82.0404V16.6859H82.0431ZM82.0431 26.7658H88.852C93.0822 26.7658 94.2004 25.1141 94.2004 23.0152C94.2004 20.5255 92.4787 19.1486 88.6687 19.1486H82.0404V26.7658H82.0431Z' fill='%23FFFFFF'/%3E%3Cpath d='M114.867 10.4591H113.231C113.646 10.8471 113.98 11.262 114.228 11.7605C114.449 12.2859 114.56 12.8679 114.56 13.5335C114.56 14.2556 114.422 14.8915 114.145 15.4465C113.867 16.0016 113.479 16.4704 113.008 16.8045C112.509 17.1925 111.954 17.47 111.318 17.6371C110.653 17.8311 109.987 17.9119 109.268 17.9119C108.548 17.9119 107.853 17.8284 107.217 17.6371C106.552 17.47 105.999 17.1925 105.555 16.8045C105.056 16.4731 104.695 16.0016 104.42 15.4465C104.143 14.8915 104.003 14.2556 104.003 13.5335C104.003 12.8679 104.113 12.2859 104.337 11.7605C104.558 11.262 104.862 10.8471 105.307 10.4591H103.671V8.15805H107.883V6.13452H110.626V8.15805H114.864V10.4591H114.867ZM123.985 19.3535V25.3378H109.27V26.8332H124.206V29.1343H106.554V23.0395H121.296V21.6815H106.554V19.3535H123.985ZM109.27 15.6944C109.936 15.6944 110.491 15.5004 110.96 15.1124C111.404 14.7514 111.652 14.1424 111.652 13.3098C111.652 12.4772 111.402 11.8979 110.96 11.5099C110.491 11.1489 109.936 10.9549 109.27 10.9549C108.605 10.9549 108.05 11.1489 107.608 11.5099C107.136 11.8979 106.916 12.5069 106.916 13.3098C106.916 14.1128 107.136 14.7514 107.608 15.1124C108.053 15.5004 108.605 15.6944 109.27 15.6944ZM116.89 7.21499H119.55V17.9955H116.89V14.4199H113.124V12.1216H116.89V7.21499V7.21499ZM121.409 7.21499H124.068V17.9955H121.409V7.21499V7.21499Z' fill='%23FFFFFF'/%3E%3Cpath d='M127.337 25.0603H149.283V27.4152H127.337V25.0603ZM128.501 19.8519V17.4673C128.501 17.4673 128.695 17.4134 129.083 17.3003C129.471 17.2167 129.942 17.0524 130.551 16.8018C131.133 16.5808 131.772 16.2467 132.491 15.8318C133.157 15.4438 133.822 14.9184 134.458 14.2798C135.07 13.6681 135.622 12.9487 136.067 12.0623C136.509 11.2297 136.759 10.2327 136.87 9.06873V7.46014H139.917V9.06873C140.001 10.2327 140.278 11.2297 140.747 12.0623C141.192 12.9487 141.717 13.6681 142.356 14.2798C142.965 14.9184 143.63 15.4438 144.352 15.8318C145.045 16.2467 145.683 16.5808 146.292 16.8018C146.874 17.0497 147.373 17.2167 147.761 17.3003C148.149 17.4107 148.343 17.4673 148.343 17.4673V19.8519C147.54 19.7145 146.68 19.4908 145.794 19.1594C144.88 18.8549 143.994 18.4373 143.107 17.9415C142.194 17.4431 141.334 16.8611 140.529 16.1389C139.696 15.4734 139.004 14.6705 138.395 13.7274C137.786 14.6678 137.064 15.4734 136.288 16.1389C135.455 16.8611 134.625 17.4431 133.739 17.9415C132.852 18.44 131.939 18.8549 131.052 19.1594C130.139 19.4908 129.279 19.7145 128.503 19.8519' fill='%23FFFFFF'/%3E%3Cpath d='M158.067 22.2069V15.9153H150.668V13.5604H158.067V10.0684H150.668V7.68651H160.837V13.2263H163.609V7.18803H166.269V28.4984H163.609V15.6109H160.837V22.2069H158.067ZM170.787 29.2178H168.128V7.18803H170.787V29.2178Z' fill='%23FFFFFF'/%3E%3Cpath d='M191.095 7.18805H193.838V29.1074H191.095V15.8049H187.797C187.687 16.8854 187.409 17.8284 187.021 18.6044C186.604 19.4074 186.108 20.0729 185.496 20.5983C184.858 21.1534 184.138 21.5414 183.362 21.7892C182.53 22.0668 181.7 22.2042 180.813 22.2042C179.816 22.2042 178.9 22.0668 178.07 21.7327C177.211 21.4282 176.462 20.9567 175.853 20.3181C175.214 19.7091 174.716 18.9062 174.355 17.9631C173.967 17.0497 173.8 15.9666 173.8 14.6921C173.8 13.4176 173.967 12.3371 174.355 11.3941C174.716 10.451 175.214 9.67502 175.853 9.03914C176.491 8.40325 177.211 7.98561 178.07 7.65419C178.903 7.34972 179.816 7.18266 180.813 7.18266C181.7 7.18266 182.532 7.32008 183.335 7.57066C184.111 7.84819 184.831 8.23619 185.469 8.73466C186.078 9.28972 186.577 9.92561 186.994 10.7016C187.382 11.4776 187.66 12.391 187.77 13.4446H191.095V7.18805ZM180.843 19.5744C181.398 19.5744 181.953 19.4909 182.452 19.2699C182.95 19.1056 183.365 18.7984 183.753 18.3835C184.114 17.9955 184.419 17.497 184.639 16.8584C184.86 16.2495 184.971 15.5274 184.971 14.6678C184.971 13.8083 184.86 13.1158 184.639 12.4799C184.419 11.871 184.111 11.3725 183.753 10.9549C183.365 10.5669 182.95 10.2624 182.452 10.0415C181.953 9.87441 181.398 9.76394 180.843 9.76394C180.261 9.76394 179.736 9.87441 179.234 10.0415C178.736 10.2624 178.294 10.5669 177.933 10.9549C177.545 11.3725 177.241 11.871 177.047 12.4799C176.826 13.1185 176.712 13.8379 176.712 14.6678C176.712 15.4977 176.823 16.2468 177.047 16.8584C177.241 17.497 177.545 17.9955 177.933 18.3835C178.294 18.7984 178.736 19.1056 179.234 19.2699C179.733 19.4909 180.258 19.5744 180.843 19.5744Z' fill='%23FFFFFF'/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_22_200'%3E%3Crect width='194' height='36' fill='white'/%3E%3C/clipPath%3E%3CclipPath id='clip1_22_200'%3E%3Crect width='194' height='32.3333' fill='white' transform='translate(0 3.00049)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
    background-size: 14rem;
    background-position: 50% 50%;
    background-repeat: no-repeat;
}
.btn-home::after {
    content:"";
    position: absolute;
    right: -1rem;
    display: block;
    width: .8rem;
    height: 1.1rem;
    background-size: .8rem;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-image: url("data:image/svg+xml,%3Csvg width='6' height='11' viewBox='0 0 6 11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_22_205)'%3E%3Cpath d='M0.437414 0.674402L5.37483 5.61182L0.437414 10.5492' stroke='%239E9A94' stroke-width='0.785714' stroke-linecap='round'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_22_205'%3E%3Crect width='6' height='11' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
}
.btn-urlcopy{
    min-height: 6rem;
    padding: 0 2.4rem;
    color: #8E581D !important;
    font-size: 1.8rem;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    border-radius: 1.6rem;
    gap: .8rem;
    box-shadow: 0 .3rem 1.6rem #E1DDCA;
    white-space: nowrap;
}
.btn-urlcopy::before{
    content:"";
    display: block;
    width: 3rem;
    height: 3rem;
    background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cmask id='mask0_22_218' style='mask-type:alpha' maskUnits='userSpaceOnUse' x='3' y='4' width='24' height='23'%3E%3Cpath d='M9.71964 26.0909H20.6287C23.842 26.0909 26.4469 23.486 26.4469 20.2727V14.8182V10.0909C26.4469 6.87761 23.8415 4.27272 20.6282 4.27272H14.8105H9.71964C6.50635 4.27272 3.90146 6.87761 3.90146 10.0909V20.2727C3.90146 23.486 6.50634 26.0909 9.71964 26.0909Z' fill='%23D9D9D9'/%3E%3C/mask%3E%3Cg mask='url(%23mask0_22_218)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M26.4433 22.4549H11.8979C9.48792 22.4549 7.53425 20.5012 7.53425 18.0912V4.27304C7.53425 4.16954 7.53785 4.06688 7.54494 3.96518C5.40788 4.82602 3.89948 6.91891 3.89948 9.36411V20.2732C3.89948 23.4865 6.50437 26.0914 9.71766 26.0914H21.354C23.8 26.0914 25.8934 24.5821 26.7537 22.444C26.6512 22.4512 26.5477 22.4549 26.4433 22.4549Z' fill='%23C3A482'/%3E%3C/g%3E%3Cpath d='M26.4494 15.5454V20.2727C26.4494 23.486 23.8446 26.0909 20.6313 26.0909H9.72217C6.50888 26.0909 3.90399 23.486 3.90399 20.2727V10.0909C3.90399 6.87761 6.50888 4.27272 9.72217 4.27272H13.3585' stroke='%2326282C' stroke-width='1.82515' stroke-linecap='round'/%3E%3Cpath d='M20.9421 3.45496L18.4876 5.90941C17.1321 7.26497 17.1321 9.46276 18.4876 10.8183L19.0246 11.3552L19.7933 11.9515C20.2517 12.3071 20.8154 12.5 21.3956 12.5C22.1015 12.5 22.7774 12.2146 23.2696 11.7086L26.2252 8.6702C27.5488 7.30945 27.5338 5.13777 26.1915 3.79544L25.851 3.45496C24.4954 2.0994 22.2976 2.0994 20.9421 3.45496Z' fill='%23FFD633'/%3E%3Cpath d='M21.0166 7.73871L21.5535 8.27563C22.9091 9.63118 22.9091 11.829 21.5535 13.1845L19.099 15.639C17.7435 16.9945 15.5457 16.9945 14.1901 15.639L13.8833 15.3322C12.5278 13.9766 12.5278 11.7788 13.8833 10.4233L17.0281 7.2785' stroke='black' stroke-width='1.59538' stroke-linecap='round'/%3E%3Cpath d='M19.025 11.2671L18.4881 10.7302C17.1325 9.37467 17.1325 7.17688 18.4881 5.82132L20.9426 3.36687C22.2981 2.01131 24.4959 2.01131 25.8515 3.36687L26.1583 3.67367C27.5138 5.02923 27.5138 7.22702 26.1583 8.58258L21.9397 12.8012' stroke='black' stroke-width='1.59538' stroke-linecap='round'/%3E%3C/svg%3E%0A");
}

@media (max-width:1124px) {
    /* .healthCheck-wrap {
        gap:0;
        justify-content: space-around;
        padding:0 4vw;
    } */
}
@media (max-width:1124px) {
    
    /* .healthCheck-head-group {
        transform: scale(.8);
        transform-origin: 0 100%;
        gap:1.2rem;
    } */
   
    /* .healthCheck-head-tit {
        font-size:4.8vw;
    } */
}
@media (max-width:960px) {
    .healthCheck-iframe-nav{display: flex;}
    .healthCheck-wrap{padding:0;}
    .healthCheck-head{display: none !important;}
    .healthCheck-iframe{width: 100dvw; }
    .healthCheck-iframe iframe{height: calc(100dvh - 3rem);}

}
</style>
  
